/** Company name seeded with the user's email during Stripe signup — not a real company name. */
export function isPlaceholderCompanyName(
    companyName: string | undefined | null,
    email: string | undefined | null,
): boolean {
    if (!companyName?.trim() || !email?.trim()) {
        return false;
    }
    return companyName.trim().toLowerCase() === email.trim().toLowerCase();
}

export type AdminProfileSetupFields = {
    title?: string | null;
    telephone?: string | null;
    companyName?: string | null;
    cleverSchoolName?: string | null;
    email?: string | null;
};

/**
 * Whether a real company or Clever school name is present.
 * Email placeholders seeded during signup do not count.
 */
export function hasValidCompanyOrSchool(profile: AdminProfileSetupFields): boolean {
    if ((profile.cleverSchoolName ?? "").trim()) {
        return true;
    }
    const companyName = (profile.companyName ?? "").trim();
    if (!companyName) {
        return false;
    }
    return !isPlaceholderCompanyName(companyName, profile.email);
}

/** Whether an admin/staff user has finished first-time profile setup (title, phone, company/school). */
export function isAdminStaffProfileSetupComplete(profile: AdminProfileSetupFields): boolean {
    if (!(profile.title ?? "").trim()) {
        return false;
    }
    if (!(profile.telephone ?? "").trim()) {
        return false;
    }
    return hasValidCompanyOrSchool(profile);
}
